export default __webpack_public_path__ + "static/media/EDISON_DS-BoK-release2-v04.4191bff8.pdf";